'use strict';

const isDragging = {
    x: false,
    y: false,
};
function isDragActive() {
    return isDragging.x || isDragging.y;
}

exports.isDragActive = isDragActive;
exports.isDragging = isDragging;
//# sourceMappingURL=is-active.cjs.map
